import { Injectable, Optional, SkipSelf } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, map, Observable } from 'rxjs';
import { LocalizationConfigService } from './localization-config.service';
import { HttpClient } from '@angular/common/http';
import { Locale } from 'src/app/models/locale.model';
import { escape } from '@rxweb/reactive-form-validators';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  private _localeId: string = 'es'; // default
  private _locales: Locale[] = [];

  /**
   * @constructor
   * @param {LocalizationService} singleton - the localization service
   * @param {LocalizationConfigService} config - the localization config
   * @param {TranslateService} translateService - the translate service
   */
  constructor(
    @Optional() @SkipSelf() private singleton: LocalizationService,
    private config: LocalizationConfigService,
    private translateService: TranslateService,
    private httpClient: HttpClient
  ) {
    if (this.singleton) {
      throw new Error(
        'LocalizationService is already provided by the root module'
      );
    }
    this._localeId = this.config.locale_id;
  }

  /**
   * Initialize the service.
   * @returns {Promise<void>}
   */
  public initService(): Promise<any> {

    // language code same as file name.
    this._localeId = localStorage.getItem('locale') || 'es';

    //let getLocalesFromApi: Observable<any> = this.getLocalesFromApi();
    const joined$ = forkJoin(
        this.useLanguage(this._localeId),
        //getLocalesFromApi
    );

    return joined$.toPromise();
  }

  /**
   * change the selected language
   * @returns {Promise<void>}
   */
  public useLanguage(lang: string): Promise<void> {
    localStorage.setItem('locale', lang);

    this.translateService.setDefaultLang(lang);
    return this.translateService
      .use(lang)
      .toPromise()
      .catch(() => {
        throw new Error('LocalizationService.init failed');
      });
  }

  /**
   * Gets the instant translated value of a key (or an array of keys).
   * @param key
   * @param interpolateParams
   * @returns {string|any}
   */
  public translate(key: string | string[], interpolateParams?: object): string {
    return this.translateService.instant(key, interpolateParams) as string;
  }

  public translate$(key: string | string[], interpolateParams?: object): Observable<any> {
    return this.translateService.stream(key, interpolateParams);
  }

  getSiteLocales(): Locale[] {
    // TODO: populate with the site locales needed
    return null; 
  }

  getCurrentLang(): string {
    return this.translateService.currentLang;
  }

  getCurrentLangId(): number {
      return 1; 
  }

  getCurrentLang$(){
    return this.translateService.onLangChange;
  }

  getLocales(): Locale[]{
    return this._locales;
  }
}
